<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title icon="mdi-play-box-outline" :desc="$t('SLIDER.LIST.SUB_TITLE')">
          <template v-slot:title>
            <span class="mr-5">{{ $t("SLIDER.LIST.TITLE") }}</span>
            <div>
              <v-btn dark :to="`${$route.path}/slider-ekle`" small color="deep-purple darken-4" class="mr-4">
                <v-icon size="18" left>mdi-plus-thick</v-icon>
                {{ $t("SLIDER.LIST.ADD_SLIDER_BTN") }}
              </v-btn>
            </div>
          </template>
        </panel-title>
      </v-col>

      <v-col v-if="!sliderListesi">
        <v-card class="mb-3" min-height="75">
          <v-skeleton-loader class="elevation-0 transparent pt-3" type="table-heading"></v-skeleton-loader>
        </v-card>
        <v-card class="mb-3" min-height="75">
          <v-skeleton-loader class="elevation-0 transparent pt-3" type="table-heading"></v-skeleton-loader>
        </v-card>
        <v-card class="mb-3" min-height="75">
          <v-skeleton-loader class="elevation-0 transparent pt-3" type="table-heading"></v-skeleton-loader>
        </v-card>
      </v-col>

      <v-col v-if="!sliderListesi.length">
        <p class="d-flex justify-center align-center text-h5 font-weight-medium grey--text mt-8">
          <v-icon size="2rem" color="grey" left>mdi-emoticon-sad-outline</v-icon>
          {{ $t("SLIDER.LIST.NO_SLIDER_ADDITIONAL") }}
        </p>
      </v-col>

      <v-col cols="12" v-else>
        <v-card elevation="1" class="px-4" :key="key" v-for="(slider, key) in sliderListesi">
          <v-row class="d-flex align-center mb-4">
            <v-col cols="12" lg="3" class="d-flex align-center">
              <div class="mr-4">
                <v-icon size="30" color="deep-purple darken-2">mdi-play-box</v-icon>
              </div>
              <div>
                <div class="text-subtitle-1">
                  <b>{{ slider.name }}</b>
                </div>
                <div class="text-subtitle-2 grey--text text--darken-2">{{ slider.desc }}</div>
              </div>
            </v-col>
            <v-col cols="5" sm="4" lg="3">
              <v-chip color="deep-purple lighten-5" class="px-5">
                <span class="deep-purple--text text--darken-4">{{ $t("SLIDER.LIST.SLIDER_ITEM_ID") }}: {{ slider.code }}</span>
              </v-chip>
            </v-col>
            <v-col cols="7" sm="4" lg="3" class="d-flex justify-end">
              <v-btn color="deep-purple darken-2" class="px-7" dark rounded small>
                <v-icon left>mdi-gesture-tap-box</v-icon>
                {{ $t("SLIDER.LIST.SLIDER_ITEM_TEXT", { COUNT: slider.items }) }}
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4" lg="3" class="d-flex align-center justify-end">
              <div>
                <v-btn fab x-small color="blue" dark class="mr-3" :to="`${$route.path}/slider-duzenle/${slider.code}`">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn fab x-small color="red" dark @click="sliderKaldirDialog(slider.code)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="sliderKaldir.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("SLIDER.REMOVE_SLIDER_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>{{ $t("SLIDER.REMOVE_SLIDER_DIALOG.INFO_CONTENT") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="sliderKaldir.dialog = false">
            {{ $t("SLIDER.REMOVE_SLIDER_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="sliderKaldir.loading" @click="sliderKaldirFn()">
            {{ $t("SLIDER.REMOVE_SLIDER_DIALOG.YES_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PanelTitle from "../../../components/PanelTitle.vue";
import { mapState } from "vuex";

export default {
  components: { PanelTitle },
  name: "SliderListesi",
  data: () => ({
    sliderKaldir: {
      code: 0,
      dialog: false,
      loading: false
    }
  }),
  computed: {
    ...mapState({
      sliderListesi: state => state.Slider.SliderListesi.sliderListesi
    })
  },
  methods: {
    sliderKaldirDialog(sliderCode) {
      this.sliderKaldir.code = sliderCode;
      this.sliderKaldir.dialog = true;
    },
    sliderKaldirFn() {
      this.sliderKaldir.loading = true;
      this.$store
        .dispatch("Slider/SliderListesi/sliderKaldir", this.sliderKaldir.code)
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("SLIDER.NOTIFY.SLIDER_REMOVE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.sliderKaldir.dialog = false;
            return (this.listStatus = true);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.sliderKaldir.loading = false;
        });
    }
  },
  created() {
    this.$store.dispatch("Slider/SliderListesi/sliderListesi");
  }
};
</script>

<style></style>
